export default "__VITE_ASSET__B6vT28TW__"